export enum CUTOUTS_OPTIONS {
    OUTLET_CUTOUT = 'OUTLET_CUTOUT',
    FAUCET_HOLES = 'FAUCET_HOLES',
    UNPOLISHED_CUTOUT = 'UNPOLISHED_CUTOUT',
}
